module.exports = __webpack_public_path__ + "media/creation.0b83c193.mp3";